import React, { useEffect } from 'react'
import { format, parse } from 'date-fns'

import { Skeleton } from '@material-ui/lab'
import { isEmpty } from 'lodash'
import TableBorderless from '../../common/TableBorderless'
import { formatCentsToPrettyDollars } from '../perks/giftCardUtils'
import { ROWS_PER_PAGE } from './adminUtils'

const TableGiftTransactions = ({
  teamId,
  giftTransactions: { content, number: page, totalElements },
  loadGiftTransactionsStart,
}) => {
  const handlePageChange = (e, page) => {
    loadGiftTransactionsStart(teamId, page, ROWS_PER_PAGE)
  }

  const columns = [
    {
      id: 'purchaseDate',
      label: 'Date',
    },
    {
      id: 'purchaserName',
      label: 'Purchaser',
    },
    {
      id: 'reason',
      label: 'Reason',
    },
    {
      id: 'numberOfGifts',
      label: 'Quantity',
    },
    {
      id: 'totalGiftAmount',
      label: 'Total',
    },
  ]

  const rowCells = content?.map(giftTransaction => ({
    id: giftTransaction.id,
    cells: [
      {
        labelId: 'purchaseDate',
        Component: format(parse(giftTransaction.purchaseDate), 'M/D/YYYY'),
      },
      {
        labelId: 'purchaserName',
        Component: giftTransaction.purchaserName,
      },
      {
        labelId: 'reason',
        Component: giftTransaction.reason,
      },
      {
        labelId: 'numberOfGifts',
        Component: giftTransaction.numberOfGifts,
        align: 'center',
      },
      {
        labelId: 'totalGiftAmount',
        Component: formatCentsToPrettyDollars(giftTransaction.totalGiftAmount),
      },
    ],
  }))

  return (
    <TableBorderless
      columns={columns}
      rowCells={rowCells}
      rowsPerPage={ROWS_PER_PAGE}
      totalElements={totalElements}
      page={page}
      ariaLabel="billing history gift transactions table"
      noDataText="No gift transactions found"
      onChangePage={handlePageChange}
    />
  )
}

const LoadableTableGiftTransactions = props => {
  const { teamId, loading, giftTransactions, loadGiftTransactionsStart } = props

  useEffect(() => {
    if (teamId) {
      loadGiftTransactionsStart(teamId, 0, ROWS_PER_PAGE)
    }
  }, [loadGiftTransactionsStart, teamId])

  if (loading) return <Skeleton variant="rect" height="200px" />

  return !isEmpty(giftTransactions) && <TableGiftTransactions {...props} />
}

export default LoadableTableGiftTransactions
